import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {RowCellViewModule} from '@aztrix/components/row-cell-view';
import {SearchQueryModule} from '@aztrix/components/search-query';
import {HelperPipesModule} from '@aztrix/helpers';
import {IconsModule} from '@aztrix/icons';

import {LanguageSelectorModalComponent} from './language-selector-modal.component';

@NgModule({
  declarations: [LanguageSelectorModalComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    IconsModule,
    HelperPipesModule,
    RowCellViewModule,
    SearchQueryModule,
  ],
  exports: [LanguageSelectorModalComponent],
})
export class LanguageSelectorModalModule {}
